import { defineComponent as _defineComponent } from 'vue'
import { IEventUserChip } from '@/enitites/event'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventStaffUserChip',
  props: {
    user: null
  },
  setup(__props: any) {

const { getImageById } = useImage()


return { __sfc: true,getImageById }
}

})